// 区分ios版本
export function judegIOSVersion() {
  var ver = navigator.appVersion.match(/OS (\d+)_(\d+)_?(\d+)?/);
  ver = parseInt(ver[1], 10);
  return ver;
}

// 获取链接上的query值
export function getQueryString(name) {
  var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
  var r =
    window.location.search.substr(1).match(reg) ||
    window.location.hash
      .substring(window.location.hash.search(/\?/) + 1)
      .match(reg);
  if (r != null) {
    return decodeURIComponent(r[2]);
  }
  return null;
}

// 前端生成不重复的UUID
export function createUuid() {
  let s = [];
  let hexDigits = "0123456789abcdef";
  for (let i = 0; i < 36; i++) {
    s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
  }
  s[14] = "4"; // bits 12-15 of the time_hi_and_version field to 0010
  s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1); // bits 6-7 of the clock_seq_hi_and_reserved to 01
  s[8] = s[13] = s[18] = s[23] = "-";

  let uuid = s.join("");
  return uuid;
}

// 加载图片
export function loadImage(image) {
  return new Promise((resolve, reject) => {
    // 创建 image 对象加载图片；
    let img = new Image();
    // 当为线上图片时，需要设置 crossOrigin 属性；
    if (image.indexOf("http") == 0) img.crossOrigin = "*";
    img.onload = () => {
      resolve(img);
      // 使用完后清空该对象，释放内存；
      setTimeout(() => {
        img = null;
      }, 1000);
    };
    img.onerror = () => {
      reject(`图片加载失败:${image}`);
    };
    img.src = image;
  });
}

//vip系统处理请求传参
export function handleParam(param) {
  if (!param) {
    return "";
  }
  let str = [];
  Object.keys(param).forEach(key => {
    str.push(`${key}=${encodeURIComponent(param[key])}`);
  });
  return str.join("&");
}

// 判断是否是蓝TV app 客户端
export function isTv() {
  let ua_str = window.navigator.userAgent.toLowerCase();
  if (/chinabluetv/.test(ua_str)) {
    return true;
  } else {
    return false;
  }
}

// 跳转蓝tv app
export function callUpApp(url) {
  window.callUpApp(url);
}

// 初始化蓝tv app SDK
export function initShareApp() {
  const shareData = {
    showShareBtn: true,
    url: window.shareLink, //分享的网址链接
    title: this.shareTitle, //分享的标题
    content: this.shareDesc, // 分享的文字
    img: this.shareImg // 分享的图片Url
  };
  return new ShareApp("true", shareData);
}
